import { createAction, props, union } from '@ngrx/store';
import { Login } from '../../model/login.model';

export enum AuthActionTypes {
    Login = '[Auth] Login',
    LoginSuccess = '[Auth] Login Success',
    LoginFailure = '[Auth] Login Failure',
    Logout = '[Auth] Logout',
    RefreshToken = '[Auth] Refresh Token',
    ClearMessage = '[Auth] Clear Message',
    UpdateBundleRecurring = '[Auth] Update Bundle Recurring'
}

export const login = createAction(
    AuthActionTypes.Login,
    props<{ credentials: Login }>()
);

export const loginSuccess = createAction(
    AuthActionTypes.LoginSuccess,
    props<{ payload: { access_token: string, xBundleRecurring: string } }>()
);

export const loginFailure = createAction(
    AuthActionTypes.LoginFailure,
    props<{ message: string }>()
);

export const logout = createAction(
    AuthActionTypes.Logout
);

export const refreshToken = createAction(
    AuthActionTypes.RefreshToken
);

export const clearMessage = createAction(
    AuthActionTypes.ClearMessage
);

export const updateBundleRecurring = createAction(
    AuthActionTypes.UpdateBundleRecurring,
    props<{ xBundleRecurring: string }>()
);

const actions = union({
    login,
    loginSuccess,
    loginFailure,
    logout,
    refreshToken,
    clearMessage,
    updateBundleRecurring
});

export type AuthActionsUnion = typeof actions;
